import React, { useState, useEffect, useMemo } from 'react';
import { Route, Switch, NavLink, useRouteMatch, useLocation, Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import classNames from 'classnames';
import qs from 'qs';

import Main from './Main';
import Referrals from './Referrals';
import Payouts from './Payouts';
import Loader from '../../components/Loaders/Loader';

import { getNavbarCountersAction } from '../../redux/actions/header';
import { getConfig } from '../../services/endpoints/affiliates';
import { pageWrapperScrollTop } from '../../utils/helper';

const routesComponents = {
  affiliates: Main,
  referrals: Referrals,
  payouts: Payouts,
};

const Affiliates = () => {
  const { url } = useRouteMatch();
  const location = useLocation();
  const dispatch = useDispatch();

  const queryString = qs.parse(location.search.slice(1));

  const [config, setConfig] = useState({});
  const [activeTab, setAtiveTab] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const routes = useMemo(
    () => config?.affiliates?.map((item) => {
      if (item?.code === 'affiliates') {
        return {
          ...item,
          component: routesComponents[item.code],
          exact: true,
          to: item?.url?.replace('/admin', ''),
        };
      }
      return {
        ...item,
        component: routesComponents[item.code],
        exact: false,
        to: item?.url?.replace('/admin', ''),
      };
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [config, url],
  );

  const fetchConfig = async () => {
    setIsLoading(true);
    try {
      const response = await getConfig(queryString);
      if (response.success) {
        setConfig(response.data);
        setIsLoading(false);
        return response.data;
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    dispatch(getNavbarCountersAction({ code: 'affiliates-list' }));
    fetchConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setAtiveTab(location.pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    if (queryString.page) {
      pageWrapperScrollTop();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryString.page]);

  return (
    <Grid fluid>
      {isLoading ? (
        <Loader />
      ) : (
        <Row>
          <Col md={2}>
            <ul className="p-b nav nav-pills nav-stacked page-tabs">
              {routes?.map((route, index) => (
                <li
                  key={index}
                  className={classNames('', {
                    active: activeTab === route.to,
                  })}
                >
                  <NavLink to={route.to} onClick={() => setAtiveTab(route.to)}>
                    {route.title}
                  </NavLink>
                </li>
              ))}
            </ul>
          </Col>

          <Col md={10}>
            <Switch>
              {routes?.map((route) => (
                <Route key={route.code} exact={route.exact} path={route.to}>
                  <route.component config={config} />
                </Route>
              ))}
              <Redirect to={routes?.[0]?.to || '/'} />
            </Switch>
          </Col>
        </Row>
      )}
    </Grid>
  );
};

export default Affiliates;
